import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../../../../constants/index";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import {
  GetServiceCaller,
  PostServiceCaller,
  PostFormServiceCaller,
} from "../../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import moment from "moment";
import { toast } from "react-toastify";
import DeleteModal from "../../../../components/DeletePopUpComponent";

function ScheduleInterview() {
  const navigate = useNavigate();
  const [scheduledInterwiewdetails, setScheduledInterwiewdetails] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const location = useLocation();
  const passedState = location.state;

  const wrapWithTooltip = (dataArray) => {
    return (dataArray || []).map(item => ({
      ...item,
      RequisitionID: item.RequisitionID ? (
        <span data-job-inactive={item.isJobInactive}>
          {item.RequisitionID}
        </span>
      ) : "",
      RecallRemarks: item.RecallRemarks || "",
    }));
  };

  useEffect(() => {
    const timer = setInterval(() => {
      const rows = document.querySelectorAll("#skill-table-area table tbody tr");
      rows.forEach(row => {
        const inactiveSpan = row.querySelector("span[data-job-inactive='1']");
        if (inactiveSpan) {
          row.style.opacity = "0.5";
          row.style.pointerEvents = "none";
        }
      });
    }, 500);
    return () => clearInterval(timer);
  }, []);

  const columns = {
    RequisitionID: { text: "Requisition ID", align: "start", visible: false },
    JobTitle: { text: "Job Title", align: "start", visible: true },
    Interviewee: { text: "Interviewee", align: "start", visible: true },
    Interviewer: { text: "Interviewer", align: "start", visible: true },
    ReferralName: { text: "Referred By", align: "start", visible: true },
    InterviewDate: { text: "Interview Date", align: "center", visible: true },
    InterviewTime: { text: "Time", align: "center", visible: true },
    Location: { text: "Mode", align: "start", visible: true },
    Round: { text: "Round", align: "center", visible: true },
    IsFinalRound: { text: "Final Round", align: "center", visible: true },
    IsInActive: { text: "Active", align: "center", visible: true },
    CreatedByName: { text: "Created By", align: "start", visible: true },
    RecallRemarks: { text: "Remarks", align: "start", visible: false },
  };

  const dispatch = useDispatch();
  useEffect(() => {
    fetchJob();
    dispatch(updateNavbarHeading(passedState ? passedState?.text : "Scheduled Interviews"))
  }, [passedState])


  const [originalData, setOriginalData] = useState([]);


  // Apply URL filters
  useEffect(() => {
    if (originalData.length === 0) return;

    const queryParams = new URLSearchParams(location.search);
    const fromDate = queryParams.get('FromDate');
    const toDate = queryParams.get('ToDate');
    const round = queryParams.get('Round');
    const fround = queryParams.get('IsFinalRound');

    console.log("fromDate toDate", fromDate, toDate);

    const filteredData = originalData.filter(item => {
      const interviewDate = moment(item.InterviewDate, "DD-MMM-YYYY");

      const fromCondition = fromDate
        ? interviewDate.isSameOrAfter(moment(fromDate, "DD-MM-YYYY"))
        : true;

      const toCondition = toDate
        ? interviewDate.isSameOrBefore(moment(toDate, "DD-MM-YYYY"))
        : true;

      const rounds = round
        ? item.Round?.trim()?.toLowerCase() === round?.trim()?.toLowerCase()
        : true;
      const Frounds = fround
        ? item.IsFinalRound === fround
        : true;

      return fromCondition && toCondition && rounds && Frounds;
    });

    setScheduledInterwiewdetails(wrapWithTooltip(filteredData));
  }, [location.search, originalData]);


  const [apiStatus, setApiStatus] = useState(undefined)
  const fetchJob = async () => {


    setApiStatus(undefined)
    try {
      const response = await GetServiceCaller(`${API_URL}scheduleinterviews`);
      setApiStatus(response?.status)
      if (response?.status === 200) {
        const apidata = response?.data?.data?.headers?.map(el => ({
          ...el,
          isCancel: el?.TeamsEventId ? 1 : 0
        }));
        const wrapped = wrapWithTooltip(apidata);
        setScheduledInterwiewdetails(wrapped);
        setOriginalData(wrapped);
      }
    } catch (error) {
      console.error("Error fetching job:", error);
    }
  };
  const handleViewpage = (state) => {
    navigate("/schedule-interview-list/view-interview/" + state.ID);
  };
  const handleEditpage = (state) => {
    navigate("/schedule-interview-list/edit-interview/" + state.ID);
  };


  const [selectedDeleteItem, setSelectedDeleteItem] = useState([])

  const handleInterviewCancel = async (data) => {
    setShowDeleteModal(true);
    setSelectedDeleteItem(data);

  }



  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleModalDelete = async () => {
    if (selectedDeleteItem) {
      try {
        let response;
        response = await PostServiceCaller(`${API_URL}schedule-interview/cancelInterview`, { TeamsEventId: selectedDeleteItem?.TeamsEventId }, "post");

        if (response?.status == 200) {
          toast.success("Interview cancelled successfully.");
        }
      } catch (error) {
        console.error("Interview Cancelled API Error:", error);

      }
    }
  };

  const handleDeleteClose = () => {
    setShowDeleteModal(false);
    setSelectedDeleteItem(null);

  };
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={scheduledInterwiewdetails}
              columns={columns}
              isRequiredStatus={true}
              isApiStatus={apiStatus}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              showIcon2={true}
              showIcon3={true}
              isSorting={true}
              handleIcon1={handleViewpage}
              handleIcon2={handleEditpage}
              handleIcon3={handleInterviewCancel}
              isActionRequired={true}
              add
              more
              function
              icons={{
                Icon1: <i class="bi bi-eye-fill"></i>,
                Icon1Text: 'View',
                Icon2: <i class="bi bi-pencil-square  icons"></i>,
                Icon2Text: 'Reschedule',
                Icon3: <i class="bi bi-x-square icons"></i>,
                Icon3Text: 'Cancel',
                Icon3Flag: 'isCancel',
              }}
            />
          </div>
        </div>

        <DeleteModal
          show={showDeleteModal}
          onClose={handleDeleteClose}
          onConfirm={handleModalDelete}
          modalTitle="Cancel Interview"
          message="Are You Sure You Want to Cancel Interview?"
          submitBtnLabel="Yes, Cancel Interview"
          cancelBtnLabel="Close"
        />
      </div>

    </>
  );
}

export default ScheduleInterview;
